import axios from 'axios';
import * as environmentService from '../environment/environmentService';
import * as oauthService from '../oauth/oauthService';

const DocumentService = {
    getDocumentInfo: (docGUI) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/documentinfo/${docGUI}`, oauthService.oauthHeaders());
    },

    getDisclaimerMessage: (signerGUI, type, language) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/pendingsignatures/${signerGUI}/disclaimertext/${type}/${language}`, oauthService.oauthHeaders());
    },

    renderAttachment: (signerGUI, attachmentGuid) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/signatures/${signerGUI}/attachments/${attachmentGuid}/render`, oauthService.oauthHeaders());
    },

    getDocumentAttatchments: (signerGUI) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/signatures/${signerGUI}/attachments/`, oauthService.oauthHeaders());
    },

    rejectDocument: (signerGUI, rejectBody) => {
        return axios.post(`${environmentService.getVidCloudPrivUrl()}/vidmobileuser/signature/${signerGUI}/rejected`, rejectBody, oauthService.oauthHeaders());
    },

    uploadLocalSignatureCertificate: (signerGUI, certificateBody) => {
        return axios.post(`${environmentService.getVidCloudPrivUrl()}/localsignature/${signerGUI}/certificate`, certificateBody, oauthService.oauthHeaders());
    },

    getPreSignature: (signerGUI) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/presignature?SignatureId=${signerGUI}`, oauthService.oauthHeaders());
    },

    uploadLocalSignature: (signerGUI, signatureBody) => {
        return axios.post(`${environmentService.getVidCloudPrivUrl()}/localsignature/${signerGUI}`, signatureBody, oauthService.oauthHeaders());
    },

    downloadDocument: (docGuid) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/documents/${docGuid}`, oauthService.oauthHeaders());
    },

    downloadDocumentAttachment: (signerGuid, attachmentGuid) => {
        return axios.get(`${environmentService.getVidCloudPrivUrl()}/signatures/${signerGuid}/attachments/${attachmentGuid}`, oauthService.oauthHeaders());
    }
};

export default DocumentService;

